// Feature Overview
// https://github.com/NBCUDTC/core-video-team/discussions/11051
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { sdkLogger } from '../../logger';
import { VideoColourSpace, VideoFormat } from './video-format';
// A group of compatible player capabilities
// A specification of which streams are available for us to request from the video platform (e.g. OVP)
// Based on the available streams for a given playback type we will request the best
// stream capability group.
// Prioritise by frame rate, then video format, then colour space
// Reverse order sorting so that higher enum values (better stream specs) are at the front of the array.
// i.e. Prefer 60fps SDR to 30fps HDR
//
// This could be shifted out into the proposition extensions if each proposition
// wanted a different prioritisation order but for now it makes sense to sit here
function prioritiseStreamCapabilitySpecifications(streamSpecifications) {
    return _to_consumable_array(streamSpecifications).sort(function(a, z) {
        return z.maxFrameRate - a.maxFrameRate || z.maxVideoFormat - a.maxVideoFormat || z.maxColorSpace - a.maxColorSpace;
    });
}
export function prioritiseCompatibleStreamPropertyGroups(compatibleStreamPropertyGroups) {
    return _to_consumable_array(compatibleStreamPropertyGroups).sort(function(a, z) {
        var _Math, _Math1;
        var aMaxColorSpace = (_Math = Math).max.apply(_Math, _to_consumable_array(a.supportedColourSpaces));
        var zMaxColorSpace = (_Math1 = Math).max.apply(_Math1, _to_consumable_array(z.supportedColourSpaces));
        return z.maxFrameRate - a.maxFrameRate || z.maxVideoFormat - a.maxVideoFormat || zMaxColorSpace - aMaxColorSpace;
    });
}
function getBestStreamSpecificationIndex(capabilityGroup, streamSpecifications) {
    return streamSpecifications.findIndex(function(specification) {
        return capabilityGroup.maxFrameRate >= specification.maxFrameRate && capabilityGroup.maxVideoFormat >= specification.maxVideoFormat && capabilityGroup.supportedColourSpaces.includes(specification.maxColorSpace);
    });
}
export function getPreferredCompatibleStreamPropertyGroup(capabilityGroups, streamSpecifications) {
    var prioritisedSpecifications = prioritiseStreamCapabilitySpecifications(streamSpecifications);
    var bestCapabilityGroup;
    var bestSpecificationIndex = Infinity;
    capabilityGroups.forEach(function(capabilityGroup) {
        var specificationIndex = getBestStreamSpecificationIndex(capabilityGroup, prioritisedSpecifications);
        if (specificationIndex !== -1 && specificationIndex < bestSpecificationIndex) {
            bestCapabilityGroup = capabilityGroup;
            bestSpecificationIndex = specificationIndex;
        }
    });
    if (!bestCapabilityGroup) {
        return;
    }
    var bestSpecification = prioritisedSpecifications[bestSpecificationIndex];
    if (!bestSpecification) {
        return;
    }
    return {
        maxVideoFormat: bestSpecification.maxVideoFormat,
        maxFrameRate: bestSpecification.maxFrameRate,
        supportedColourSpaces: bestCapabilityGroup.supportedColourSpaces.filter(function(c) {
            return c <= bestSpecification.maxColorSpace;
        })
    };
}
export function filterStreamsByCodecCompatibility(codecCheck, capabilityGroups) {
    return capabilityGroups.filter(function(capabilityGroup) {
        var _capabilityGroup_codecs;
        if (capabilityGroup === null || capabilityGroup === void 0 ? void 0 : (_capabilityGroup_codecs = capabilityGroup.codecs) === null || _capabilityGroup_codecs === void 0 ? void 0 : _capabilityGroup_codecs.length) {
            var _capabilityGroup_codecs1;
            return capabilityGroup === null || capabilityGroup === void 0 ? void 0 : (_capabilityGroup_codecs1 = capabilityGroup.codecs) === null || _capabilityGroup_codecs1 === void 0 ? void 0 : _capabilityGroup_codecs1.every(function(codec) {
                var result = codecCheck(codec);
                if (!result) {
                    sdkLogger.warn("Device does not support codec: ".concat(codec, ", ") + "removing capabilityGroup: ".concat(VideoFormat[capabilityGroup.maxVideoFormat].toString(), ", ") + "".concat(capabilityGroup.maxFrameRate, "fps, ") + "".concat(VideoColourSpace[capabilityGroup.maxColorSpace].toString(), "."));
                }
                return result;
            });
        }
        return true;
    });
}
export var isNowPremiumUhdSupported = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function() {
        var _CoreVideoInternal_playerCapabilities, CoreVideoInternal, compatibleStreamPropertyGroups, hasSupportedStreamGroup, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, group, fps, resolution, colourSpaces;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        import('../../core-video-internal')
                    ];
                case 1:
                    CoreVideoInternal = _state.sent().CoreVideoInternal;
                    // to avoid circular dependency with ../../core-video-internal.ts
                    compatibleStreamPropertyGroups = CoreVideoInternal === null || CoreVideoInternal === void 0 ? void 0 : (_CoreVideoInternal_playerCapabilities = CoreVideoInternal.playerCapabilities) === null || _CoreVideoInternal_playerCapabilities === void 0 ? void 0 : _CoreVideoInternal_playerCapabilities.compatibleStreamPropertyGroups;
                    hasSupportedStreamGroup = false;
                    if (!compatibleStreamPropertyGroups) {
                        return [
                            2,
                            false
                        ];
                    }
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = compatibleStreamPropertyGroups[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            group = _step.value;
                            fps = group.maxFrameRate, resolution = group.maxVideoFormat, colourSpaces = group.supportedColourSpaces;
                            if (fps >= 50 && resolution === VideoFormat.UHD && colourSpaces.includes(VideoColourSpace.HDR10)) {
                                hasSupportedStreamGroup = true;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (!hasSupportedStreamGroup) {
                        return [
                            2,
                            false
                        ];
                    }
                    return [
                        2,
                        true
                    ];
            }
        });
    });
    return function isNowPremiumUhdSupported() {
        return _ref.apply(this, arguments);
    };
}();

//# sourceMappingURL=stream-capability-specification.js.map